import { useTranslation } from '@mopla/i18';
import { CompleteAnim, MplButton, MplModal } from '@mopla/ui';

interface IMyTicketCancellationSuccessModalProps {
	open: boolean;
	onClose: () => void;
}

export const MyTicketCancellationSuccessModal = ({
	open,
	onClose,
}: IMyTicketCancellationSuccessModalProps) => {
	const { t } = useTranslation('ticketshop');
	return (
		<MplModal
			open={open}
			testId="myTicketDetail-cancellationSuccessModal"
			icon={<CompleteAnim />}
			title={t('my_ticket_detail.cancellation_success_modal.title')}
			buttons={
				<MplButton
					testId="myTicketDetail-cancellationSuccessModal-button"
					variant="contained"
					fullWidth
					onClick={onClose}
				>
					{t('my_ticket_detail.cancellation_success_modal.button')}
				</MplButton>
			}
		/>
	);
};
